import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";

const alertFontSize = "15px";

export default function CreateMessage() {
	const messageStates = useSelector((store) => store.customerGroupSetup);
	const { createMessage, createMessageSeverity, createMessageOpen } =
		messageStates;
	const dispatch = useDispatch();

	const handleCloseSnackbar = () => {
		dispatch(setCGState("createMessageOpen", false));
	};

	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={createMessageOpen}
			autoHideDuration={3000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={createMessageSeverity}
				sx={{ width: "100%", fontSize: alertFontSize }}
			>
				{createMessage}
			</Alert>
		</Snackbar>
	);
}
